export const formatCurrency = (
  number: number,
  options: { [k: string]: any } & Intl.NumberFormatOptions = {},
): string => {
  const onZero = options.onZero;
  if (!number && onZero) {
    return onZero;
  }

  delete options.onZero;

  return new Intl.NumberFormat('en-US', {
    currency: 'USD',
    ...options,
    style: 'currency',
  }).format(number);
};

export const HARD_CODED_USD_CHANGE_ME = 'USD' as const;
